import {
	PAYMENT_STATUS_REQUEST,
	PAYMENT_STATUS_SUCCESS,
	PAYMENT_STATUS_FAILURE
} from './payment-status-types';

export const paymentStatusRequest = (payload) => ({ type: PAYMENT_STATUS_REQUEST, payload });
export const paymentStatusSuccess = (response) => ({ type: PAYMENT_STATUS_SUCCESS, payload: response });
export const paymentStatusFailure = (error) => ({ type: PAYMENT_STATUS_FAILURE, payload: error });
